enum SearchType {
    Orders = 'orders',
    WorkOrders = 'workorders'
}

export default SearchType;